import React from 'react';
import {WingBlank} from '../../components';
import './SolutionBanner.less';

function Banner({data: {title, description, bg}}) {
  const style = bg ? {background: `url(${bg}) center`} : {};
  return (
    <WingBlank className='SolutionBanner' style={style}>
      <h1>{title}</h1>
      <div>{description}</div>
    </WingBlank>
  );
}

export default Banner;


// WEBPACK FOOTER //
// ./src/routes/Solution/SolutionBanner.js